import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  Navbar,
  Row,
  Col,
} from 'react-bootstrap';
import appHistory from '../../history';
import UserStore from '../../stores/UserStore';
import IconMyAccount from 'react-icons/lib/md/account-box';
import IconLogIn from 'react-icons/lib/fa/sign-in';

// components
import Logo from '../../brand/Logo';

import './Nav.css';

const LandingTopNav = observer(
class LandingTopNav extends Component {
  render() {
    const auth = UserStore.isAuthenticated();
    const text = (auth ? "My Account" : "Log In");
    const icon = (auth ? <IconMyAccount /> : <IconLogIn />);

    return (
      <Navbar className="TopNav-container" fluid inverse fixedTop>
        <Row style={{ minHeight: "50px", lineHeight: "50px" }}>
          <Col xs={7}><Logo onClick={this.logoOnClick} autoHide={false} /></Col>
          <Col xs={5} style={{textAlign: "right"}}>
          <div className="TopNav-navitem-container"
            style={{marginRight: "20px"}}
            onClick={this.onClick}>
            <span className="TopNav-navitem-icon">{icon}</span>
            <span className="TopNav-navitem-text hidden-xs">{text}</span>
          </div>
          </Col>
        </Row>
      </Navbar>
    );
  }

  onClick = () => {
    const path = UserStore.isAuthenticated() ? "/app" : "/auth";
    appHistory.push(path);
  }

  logoOnClick = () => {
    appHistory.push("/");
  }
});

export default LandingTopNav;


// WEBPACK FOOTER //
// ./src/pages/Nav/LandingTopNav.js